import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationStore } from "../stores";
import { Tags } from "../libs";
import { TagsEvent } from "../libs/tags";

export default function RouteTracker() {
  const { pathname } = useLocation();
  const pushRoute = useNavigationStore((s) => s.pushRoute);
  const isInitialLoad = useRef(true);

  useEffect(() => {
    pushRoute({ path: pathname });
    // Skip first fire — GA4 already reports the hard-load pageview.
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    } else {
      Tags.event(TagsEvent.PageView, {
        page_path: pathname,
        page_title: document.title,
      });
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, pushRoute]);

  return null;
}
